import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box, Image } from '@bottomless/common/components';
import { useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';
import { UsingContainer } from '../../ConnectStep2/components/UsingContainer';

export const TareScale = ({ timestamp }) => {
  const history = useHistory();

  const onClick = useCallback(() => {
    history.push(`/activate/step3?flow=tare&timestamp=${timestamp}`);
  }, [history, timestamp]);

  return (
    <Box secondary className="mb-4">
      <h2 className="text-center mb-4">Turn on your scale</h2>
      <div className="text-center">
        <Image
          src="/connect-scale/scale-bottom.png"
          alt="Scale setup"
          width={300}
          height={198}
          useSrcset
          className="mb-4"
        />
      </div>
      <div className="text-center mb-4">
        {
          'Press the "Setup" button on the bottom of your scale, then place it empty on a flat surface to set the "zero level".'
        }
      </div>
      <Button size="lg" color="dark" block onClick={onClick}>
        Next
      </Button>
      <UsingContainer />
    </Box>
  );
};

TareScale.propTypes = {
  timestamp: PropTypes.string.isRequired,
};
